import React, { FC } from 'react';
import usePlatformConfig from '../../../../../../../../common/react/usePlatformConfig';
import { Box, Typography } from '@material-ui/core';
import Translation from '../../../../../../../../gqlCommon/components/translation/Translation';
import summaryStyles from '../../../../summary/summarySection/SummaryStyles';
import { TaxTypes } from '../../../../../../../../../../common/enum/TaxTypes';
import { GetCustomizeCar_customizeCar_prices_totalPrice_taxes } from '../../../../../../../graphql/queries/__generated__/GetCustomizeCar';
import FeesAndChargesRow from './FeesAndChargesRow';

interface IFeesAndCharges {
  loading: boolean;
  taxes: GetCustomizeCar_customizeCar_prices_totalPrice_taxes[];
}

const FeesAndCharges: FC<IFeesAndCharges> = ({ loading, taxes }) => {
  const {
    platformConfig: { showGovernmentCharges, configurator },
  } = usePlatformConfig();
  const { summaryShowTaxes } = configurator;

  const styles = summaryStyles();

  const govCharges = taxes.find(tax => tax.type === TaxTypes.GVT);
  const aggregatedTaxes = taxes.filter(tax => tax.aggregated);

  if (!(summaryShowTaxes && aggregatedTaxes.length > 0) && !(showGovernmentCharges && govCharges?.money.amount > 0)) {
    return null;
  }

  return (
    <Box className={styles.selectionContainer} data-test="summary_expanded:section:fees_and_charges">
      <Typography component="h3" data-test="summary:selected:sectionTitle:fees_and_charges">
        <Translation id="trans__configurator__customise_page_summary_section__selection_fees_and_charges_subtitle" />
      </Typography>
      {showGovernmentCharges && govCharges?.money.amount > 0 && (
        <FeesAndChargesRow tax={govCharges} loading={loading} />
      )}
      {summaryShowTaxes && aggregatedTaxes.map(tax => <FeesAndChargesRow key={tax.type} tax={tax} loading={loading} />)}
    </Box>
  );
};
export default FeesAndCharges;
